import React, { useState, useEffect } from "react";
import { Table, Button, Input, Space, Card } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useNavigate } from 'react-router-dom';
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import XLSX from 'xlsx'
import { usePersistedStore } from "../../store/persisted-store";
import { useReportsStore } from "../../store/slices/createReportsSlice";



export default function EndorsementRejectedReport() {
    const reports = useReportsStore()
    const { business } = usePersistedStore();
    const navigate = useNavigate();

    const data = reports.endorsementRejected.data.Items;
    const loading = reports.endorsementRejected.loading;
    const [searchText, setSearchText] = useState("");
    const currentBusiness = business.currentBusiness;

    const [searchedColumn, setSearchedColumn] = useState("");
    const { token } = currentBusiness;

    let searchInput;
    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        ریست
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            ),
    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText("");
    };

    const columns = [
        {
            title: "نام بیمه گزار",
            dataIndex: "PolicyOwnerFullName",
            key: "PolicyOwnerFullName",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.PolicyOwnerFullName ? (first = a.PolicyOwnerFullName) : (first = "");
                b.PolicyOwnerFullName ? (second = b.PolicyOwnerFullName) : (second = "");
                return first.localeCompare(second);
            },
            ...getColumnSearchProps("PolicyOwnerFullName", "نام بیمه گزار"),
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "نام درخواست کننده",
            dataIndex: "ApplicantFullName",
            key: "ApplicantFullName",
            width: 150,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.ApplicantFullName ? (first = a.ApplicantFullName) : (first = "");
                b.ApplicantFullName ? (second = b.ApplicantFullName) : (second = "");
                return first.localeCompare(second);
            },
            ...getColumnSearchProps("ApplicantFullName", "نام درخواست کننده"),
            render: text => text && strings.getFarsiNum(text),
        },
        {
            title: "رشته",
            dataIndex: "BranchTitle",
            key: "BranchTitle",
            width: 90,
        },
        {
            title: "شرکت بیمه",
            dataIndex: "CompanyName",
            key: "CompanyName",
            width: 90,
        },
        {
            title: "نوع الحاقیه",
            dataIndex: "TypeTitle",
            key: "TypeTitle",
            width: 150,
        },
        {
            title: "کدالحاقیه",
            dataIndex: "EndorsementId",
            key: "EndorsementId",
            ellipsis: true,
            width: 80,
            ...getColumnSearchProps('EndorsementId', 'کدالحاقیه'),
            render: data => data && strings.getFarsiNum(data),
        },
        {
            title: "کد درخواست",
            dataIndex: "InsuranceRequestId",
            key: "InsuranceRequestId",
            ellipsis: true,
            width: 80,
            ...getColumnSearchProps('InsuranceRequestId', 'کد درخواست'),
            render: data => data && strings.getFarsiNum(data),
        },
        {
            title: "کد رهگیری",
            dataIndex: "TrackingCode",
            key: "TrackingCode",
            width: 130,
            sorter: (a, b) => a.TrackingCode.localeCompare(b.TrackingCode),
            ...getColumnSearchProps('TrackingCode', 'کد رهگیری'),
            render: text => text && text.toUpperCase().replace('BM-', '')
        },
        {
            title: "مبلغ پرداختی",
            dataIndex: "SumPayment",
            key: "SumPayment",
            width: 110,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "مبلغ مغایرت",
            dataIndex: "ContradictionAmount",
            key: "ContradictionAmount",
            width: 110,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "مبلغ",
            dataIndex: "Amount",
            key: "Amount",
            width: 110,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "کل مبلغ تخفیف",
            dataIndex: "SumDiscountsAmount",
            key: "SumDiscountsAmount",
            width: 110,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "تاریخ درخواست",
            dataIndex: "CreationTime",
            key: "CreationTime",
            width: 130,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.CreationTime ? first = a.CreationTime : first = '';
                b.CreationTime ? second = b.CreationTime : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data.CreationTime === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        }
    ];

    useEffect(() => {
        if (!token)
            navigate('/dashboard');
        reports.getEndorsementRejectedInfo();
    }, [navigate, token])

    function downloadxlsx() {
        if (!data) return
        let xlsxData = data.map(d => [
            d.PolicyOwnerFullName,
            d.ApplicantFullName,
            d.BranchTitle,
            d.CompanyName,
            d.TypeTitle,
            d.EndorsementId,
            d.InsuranceRequestId,
            d.TrackingCode,
            d.SumPayment,
            d.ContradictionAmount,
            d.Amount,
            d.SumDiscountsAmount,
            moment(d.CreationTime).format('jYYYY/jMM/jDD')
        ])
        xlsxData.unshift([
            'نام بیمه گزار',
            'نام درخواست کننده',
            'رشته',
            'شرکت بیمه',
            'نوع الحاقیه',
            'کدالحاقیه',
            'کد درخواست',
            'کد رهگیری',
            'مبلغ پرداختی',
            'مبلغ مغایرت',
            'مبلغ',
            'کل مبلغ تخفیف',
            'تاریخ درخواست'
        ])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "bimeh[dot]com.xlsx")
    }

    return (
        <Card>
            <button type="primary" className="btn btn-primary waves-effect waves-light float-left"
                htmltype="submit"
                onClick={reports.getEndorsementRejectedInfo} style={{ marginBottom: "20px" }}>
                بروزرسانی لیست &nbsp;&nbsp;&nbsp;<i className={loading ? "bx bx-loader bx-spin" : "fas fa-sync-alt"}></i>

            </button>
            <button type="primary" className="btn btn-success waves-effect waves-light float-left" style={{ marginLeft: "10px" }}
                onClick={downloadxlsx}
            >
                دریافت اکسل <i className="far fa-file-excel font-size-14 align-middle mr-2"></i>
            </button>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="small"
                bordered
                loading={loading}
                rowKey="RequestId"
                dataSource={data}
                scroll={true}
                columns={columns}
            />
        </Card>
    );
}